import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=11be0ddc&scoped=true"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=11be0ddc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11be0ddc",
  null
  
)

export default component.exports